import { addListeners } from '../../lib/eventUtils';

interface CustomEventDetail {
  type: string;
  payload: any;
}

interface CustomEventPayload {
  detail: CustomEventDetail;
}

export const REDUX_INJECT = 'REDUX_INJECT';

const customEventInterface = store => {
  let initialized = false;
  const init = () => {
    if (typeof window === 'undefined') return;
    addListeners([REDUX_INJECT], ({ detail }: CustomEventPayload) =>
      store.dispatch(detail)
    );
    initialized = true;
  };

  return next => (action: any) => {
    if (!initialized && action.type === 'INIT_MIDDLEWARE') init();
    next(action);
  };
};

export default customEventInterface;
